import { doc, deleteDoc } from "firebase/firestore";
import { db, storage } from "../../../../firebase";
import { ref, listAll, deleteObject } from "firebase/storage"; // <-- add this!
import { deleteFile } from "../../../../services/StorageServices";
/**
 * Deletes an accreditation file from Firestore and Storage.
 * @param {Object} params
 * @param {string} params.userId - The user's UID.
 * @param {string} params.folderId - The folder ID.
 * @param {Object} params.file - The file object (must have id, classificationCategory, storagePath).
 * @returns {Promise<void>}
 */
export async function deleteAccreditationFile({ userId, folderId, file }) {
  if (!userId || !folderId || !file) throw new Error("Missing required params");

  // Determine Firestore subcollection
  const isMultiPage = file.classificationCategory === "Multi-Page Documents";
  const subcollection = isMultiPage ? "multi_page" : "single_page";

  // Build Firestore document path
  const fileDocRef = doc(
    db,
    "users",
    userId,
    "folders",
    folderId,
    "accreditation_folder",
    "main",
    subcollection,
    file.id // or file.docId, depending on your structure
  );

  // Delete Firestore document
  await deleteDoc(fileDocRef);

  // Delete from Storage temp_files/
  if (file.storagePath) {
    await deleteFile(file.storagePath);

    // Get the file name from the path
    const fileName = file.fileName || file.storagePath.split("/").pop();

    /*checkings muna kung pdf yung file, para idedelete din yung na
     convert na pdf to img sa temp_files/sliced_imgs 
     */
    if (fileName && fileName.toLowerCase().endsWith(".pdf")) {
      const filenameWithoutExt = fileName.split(".").slice(0, -1).join(".");
      await deleteSlicedImageFolder(userId, filenameWithoutExt);
    }

    console.log("Accreditation file deleted from storage [SUCCESS]");
  } else {
    throw new Error("File storagePath is missing");
  }
}

// Dinidelete isa-isa ung files sa sliced_imgs
async function deleteSlicedImageFolder(userId, filenameWithoutExt) {
  const folderRef = ref(
    storage,
    `users/${userId}/temporary_files/sliced_imgs/${filenameWithoutExt}`
  );

  try {
    const listResult = await listAll(folderRef);

    // Delete each file in the folder
    const deletionPromises = listResult.items.map((item) => deleteObject(item));
    await Promise.all(deletionPromises);

    console.log(`Deleted all images in ${folderRef.fullPath}`);
  } catch (error) {
    if (error.code !== "storage/object-not-found") {
      console.error("Error deleting sliced images folder:", error);
    }
  }
}
